module.exports = __webpack_public_path__ + "img/logo.117a8ac7.png";